import Store from 'store/store';
import { fire } from 'store/bolt/trackingV2';

Store.on('TRACK_CREATIVE_SPACE_ACTIVATION', () => {
	fire('creative-space-activation');
});

Store.on('TRACK_CREATIVE_SPACE_DEACTIVATION', () => {
	fire('creative-space-deactivation');
});